import PropTypes from 'prop-types';
import React from 'react';
import { sanitizeContent, scrollToElement } from '../utils';
import SubPage from './subpage';

const Verkauf = ({ pathContext: { subparts, references } }) => {
  const { verkauf } = sanitizeContent(subparts, 'verkauf');

  return (
    <SubPage blocks={[{ content: [{ ...verkauf[0], onContact: () => scrollToElement('#kontakt') }] }]} references={references}>
    </SubPage>
  );
};

Verkauf.propTypes = {
  pathContext: PropTypes.shape({
    subparts: PropTypes.array.isRequired,
    references: PropTypes.array.isRequired,
  }),
};

export default Verkauf;



// WEBPACK FOOTER //
// ./src/templates/page.verkauf.js